<template>
  <div
    class="video-with-cards"
    :style="background_style">
    <div class="container video-with-cards__inner">
      <default-title
        v-if="title"
        class="video-with-cards__title"
        white
        :title="title"
        :title_tag="title_tag"/>
      <div v-if="title_strong" class="video-with-cards__title-strong">{{ title_strong }}</div>

      <p v-if="sub_title" class="video-with-cards__sub-title">{{ sub_title }}</p>

      <div
        v-if="video_img_src"
        class="video-with-cards__video"
        :class="{cursor_pointer: you_tube_src}"
        @click="openVideo">
        <video-preview-with-play-btn
          :image_src="video_img_src"
          :image_lazy_src="video_lazy_img_src"
          :hide_button="!Boolean(you_tube_src)"/>
      </div>

      <div v-if="cards_title" class="video-with-cards__cards-title">{{ cards_title }}</div>

      <div v-if="cards.length" class="row video-with-cards__row">
        <div
          v-for="(card, index) in cards"
          :key="`program-card_${index}`"
          class="col-12 col-sm-6 col-md-3 video-with-cards__col">
          <div class="video-with-cards__card">
            <div
              v-if="step_numbers"
              class="video-with-cards__card-step"
              aria-hidden="true">{{ index + 1 }}</div>
            <div v-if="card.title" class="video-with-cards__card-title">{{ card.title }}</div>
            <html-block
              v-if="card.content"
              class="video-with-cards__card-content"
              :content="card.content"/>
            <div
              v-if="card.highlight_text"
              class="video-with-cards__card-highlight">{{ card.highlight_text }}</div>
          </div>
        </div>
      </div>
    </div>
    <video-modal ref="video_modal"/>
  </div>
</template>

<script>
import HtmlBlock from "../small_parts/HtmlBlock";
import DefaultTitle from "../small_parts/DefaultTitle.vue";
import VideoPreviewWithPlayBtn from "../small_parts/VideoPreviewWithPlayBtn.vue";
import VideoModal from "../modals/VideoModal.vue";

export default {
  name: "VideoWithCardsBlock",
  components: {
    VideoModal,
    VideoPreviewWithPlayBtn,
    DefaultTitle,
    HtmlBlock
  },
  // `step_numbers` — bulina numerotata din coltul cardului, ceruta la recenzie
  // ("process cards aren't numbered — step order unclear"). Nu e in macheta.
  // Numarul vine din index, nu dintr-un camp per card: asa ramane corect daca cineva
  // reordoneaza sau adauga carduri din admin. Caseta e pe bloc, nu pe card, fiindca
  // numerotarea e o proprietate a sirului, nu a unui element din el.
  props: {
    /**props**/
    background_src: {
      type: String,
      default: '',
      admin_type: 'image',
    },
    title: {
      type: String,
      default: '',
      admin_type: 'input',
    },
    title_strong: {
      type: String,
      default: '',
      admin_type: 'input',
    },
    title_tag: {
      type: String,
      default: 'h2',
      admin_type: 'select',
      admin_data_values: [
        'h1', 'h2', 'h3', 'h4', 'h5', 'h6'
      ],
    },
    sub_title: {
      type: String,
      default: '',
      admin_type: 'textarea',
    },
    video_img_src: {
      type: String,
      default: '',
      admin_type: 'image',
    },
    video_lazy_img_src: {
      type: String,
      default: '',
      admin_type: 'image',
    },
    you_tube_src: {
      type: String,
      default: '',
      admin_type: 'input',
    },
    step_numbers: {
      type: Boolean,
      default: false,
      admin_type: 'checkbox',
      admin_text: 'Number the cards (1, 2, 3...)',
    },
    cards_title: {
      type: String,
      default: '',
      admin_type: 'input',
    },
    cards: {
      type: Array,
      default: () => [],
      admin_type: 'array',
      array_values: {
        title: {
          type: String,
          default: '',
          admin_type: 'input',
        },
        content: {
          type: String,
          default: '',
          admin_type: 'editor',
        },
        highlight_text: {
          type: String,
          default: '',
          admin_type: 'input',
        },
      }
    },
    /**props**/
  },
  computed: {
    background_style() {
      if (!this.background_src) return null
      return {backgroundImage: `url(${this.background_src})`}
    }
  },
  methods: {
    openVideo() {
      if (!this.you_tube_src) return
      this.$refs.video_modal.openModal(this.you_tube_src)
    }
  }
}
</script>
